import { render, staticRenderFns } from "./ApplicantOnboardingLayout.vue?vue&type=template&id=00123c21&"
import script from "./ApplicantOnboardingLayout.vue?vue&type=script&lang=js&"
export * from "./ApplicantOnboardingLayout.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantOnboardingLayout.vue?vue&type=style&index=0&id=00123c21&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports